import { useState } from "react";
import Loading from "../loading.tsx";

export default function Button(props: {
  onClick?: () => void;
  onClickLoading?: (cb: (bool: boolean) => void) => void;
  type: "primary" | "secondary" | "default" | "link" | "text";
  text?: string;
  size?: "small" | "large";
  htmlType?: "button" | "submit" | "reset";
  prefixIcon?: any;
  sufixIcon?: any;
  disabled?: boolean;
  className?: string;
  children?: any;
  fit?: boolean;
  id?: string;
  withLoadingIcon?: boolean;
  bold?: boolean;
}) {
  const buttonClassByType = {
    primary: {
      active:
        "shadow-sm border border-transparent text-white hover:bg-purple-700 bg-purple-600 focus:ring-offset-gray-50 focus:ring-purple-500",
      disabled:
        "pointer-events-none text-white bg-gray-300 border border-transparent",
    },
    secondary: {
      active:
        "shadow-sm border border-transparent text-purple-700 bg-purple-100 hover:bg-purple-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500",
      disabled: "pointer-events-none text-white bg-gray-300",
    },
    default: {
      active:
        "shadow-sm border border-gray-300 text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500",
      disabled:
        "shadow-sm border border-gray-300 pointer-events-none opacity-50 bg-white border",
    },
    link: {
      active: "text-purple-600  hover:text-purple-500 text-left px-0",
      disabled: "text-gray-400 text-left px-0 cursor-not-allowed",
    },
    text: {
      active: "text-gray-400 hover:text-gray-500 text-left px-0",
      disabled: "text-gray-300 text-left px-0 cursor-not-allowed",
    },
  };
  const [isLoading, setIsLoading] = useState(false);
  const currentClass =
    buttonClassByType[props.type][
      props.disabled || isLoading ? "disabled" : "active"
    ];
  let sizeProperty = "";

  if (props.type !== "link" && props.type !== "text") {
    sizeProperty =
      props.size == "small"
        ? "py-1 px-3 text-sm"
        : "py-2 px-3 text-sm font-normal";
  } else {
    sizeProperty = "text-sm font-normal";
  }

  const fontSizeProperty = props.bold && "font-semibold";

  if (props.type == "link" || props.type == "text") {
    return (
      <span
        id={props.id}
        onClick={() => {
          if (!props.disabled && !isLoading) {
            if (props.onClick) {
              props.onClick();
            } else if (props.onClickLoading) {
              setIsLoading(true);
              props.onClickLoading(setIsLoading);
            }
          }
        }}
        className={`cursor-pointer flex items-center ${sizeProperty} ${currentClass} ${fontSizeProperty} ${
          props.className ? props.className : ""
        }`}
      >
        {props.prefixIcon && (
          <props.prefixIcon className={`h-4 ${props.text ? "mr-1" : ""}`} />
        )}
        {props.text && props.text}
        {props.sufixIcon && !isLoading && (
          <props.sufixIcon className={`h-4 ${props.text ? "ml-1" : ""}`} />
        )}
        {isLoading && <Loading className={`ml-1 h-4 w-4`} />}
      </span>
    );
  }
  return (
    <button
      id={props.id}
      type={props.htmlType || "button"}
      onClick={() => {
        if (!props.disabled && !isLoading) {
          if (props.onClick) {
            props.onClick();
          } else if (props.onClickLoading) {
            setIsLoading(true);
            props.onClickLoading(setIsLoading);
          }
        }
      }}
      className={`flex text-center ${
        props.fit ? "w-fit" : "w-full"
      } items-center rounded-md  ${sizeProperty} ${fontSizeProperty} focus:outline-none focus:ring-2 focus:ring-offset-2 ${currentClass} ${
        props.className ? props.className : ""
      }`}
    >
      {isLoading ? (
        <div className="flex-1 flex place-content-center items-center justify-center">
          <Loading className={`h-4 w-4`} />
          <div className="ml-2">{props.text}</div>
        </div>
      ) : (
        <div className="flex-1 flex place-content-center items-center">
          {props.prefixIcon && (
            <props.prefixIcon className={`h-4 ${props.text ? "mr-2" : ""}`} />
          )}
          <div className="place-content-center">{props.text}</div>
          {props.sufixIcon && (
            <props.sufixIcon className={`h-4 ${props.text ? "ml-2" : ""}`} />
          )}
        </div>
      )}
    </button>
  );
}
